import React, {Component} from 'react';
import {Row, Col, Button, Modal, Container, Form} from 'react-bootstrap';
import Switch from 'react-switch';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

class ItemMasterAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        // BrandId: "Select Brand",
        // drugCode: "",
        // drugName: "",
        // descp: "",
        // UnitId: "Select Unit",
        // unitPrice: "",
        // taxPernct: "",
        // taxAmnt: "",
        // unitCost: "",
        // ItemCatagoryId: "Select Medical Type",
        // remarks: "",
        // batchNo: "",
        // mfgDate: "",
        // expiryDate: "",
        // hsnCode: ""
        drugCode: '',
        drugName: '',
      },
      nameError: '',
      drugCodeError: '',
    };
    this.selectBrand = this.selectBrand.bind(this);
    this.selectUnit = this.selectUnit.bind(this);
    this.selectMedicalType = this.selectMedicalType.bind(this);
    this.handleChangedate = this.handleChangedate.bind(this);
    this.handleChangeexpiryDate = this.handleChangeexpiryDate.bind(this);
  }

  validate = () => {
    let isError = false;
    let regex = /[a-z]|[a-z]\s/i;

    const errmsg1 = 'Enter a valid input';
    const errmsg2 = 'This field cannot be empty';

    const errors = {
      nameError: '',
      drugCodeError: '',
    };

    // if (!regex.test(this.state.value.drugName)) {
    //   isError = true;
    //   errors.nameError = errmsg1;
    // }
    if (this.state.value.drugName === '') {
      isError = true;
      errors.nameError = errmsg2;
    }
    // if (!regex.test(this.state.value.drugCode)) {
    //   isError = true;
    //   errors.drugCodeError = errmsg1;
    // }
    if (this.state.value.drugCode === '') {
      isError = true;
      errors.drugCodeError = errmsg2;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  selectBrand(event) {
    this.setState({
      value: {...this.state.value, BrandId: event.target.value},
    });
  }
  selectUnit(event) {
    this.setState({
      value: {...this.state.value, UnitId: event.target.value},
    });
  }
  selectMedicalType(event) {
    this.setState({
      value: {...this.state.value, ItemCatagoryId: event.target.value},
    });
  }

  handleChangedate = date => {
    this.setState({
      value: {...this.state.value, mfgDate: date},
    });
  };

  handleChangeexpiryDate = date => {
    this.setState({
      value: {...this.state.value, expiryDate: date},
    });
  };

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === 'drugCode') {
      this.setState({
        value: {...this.state.value, drugCode: value},
      });
    } else if (name === 'drugName') {
      this.setState({
        value: {...this.state.value, drugName: value},
      });
    } else if (name === 'descp') {
      this.setState({
        value: {...this.state.value, descp: value},
      });
    } else if (name === 'unitPrice') {
      this.setState({
        value: {...this.state.value, unitPrice: value},
      });
    } else if (name === 'taxPernct') {
      this.setState({
        value: {...this.state.value, taxPernct: value},
      });
    } else if (name === 'taxAmnt') {
      this.setState({
        value: {...this.state.value, taxAmnt: value},
      });
    } else if (name === 'unitCost') {
      this.setState({
        value: {...this.state.value, unitCost: value},
      });
    } else if (name === 'remarks') {
      this.setState({
        value: {...this.state.value, remarks: value},
      });
    } else if (name === 'batchNo') {
      this.setState({
        value: {...this.state.value, batchNo: value},
      });
    } else if (name === 'mfgDate') {
      this.setState({
        value: {...this.state.value, mfgDate: value},
      });
    } else if (name === 'expiryDate') {
      this.setState({
        value: {...this.state.value, expiryDate: value},
      });
    } else if (name === 'hsnCode') {
      this.setState({
        value: {...this.state.value, hsnCode: value},
      });
    } else if (name === 'mrp') {
      this.setState({
        value: {...this.state.value, mrp: value},
      });
    }
  };

  // submit = () => {
  //   // let data = this.state.value;
  //   // console.log(data);
  //   const value = this.state.value;

  //   if (
  //     value.BrandId !== "Select Brand" &&
  //     value.drugCode !== "" &&
  //     value.drugName !== "" &&
  //     value.descp !== "" &&
  //     value.UnitId !== "Select Unit" &&
  //     value.unitPrice !== "" &&
  //     value.taxPernct !== "" &&
  //     value.taxAmnt !== "" &&
  //     value.unitCost !== "" &&
  //     value.ItemCatagoryId !== "Select Medical Type" &&
  //     value.remarks !== "" &&
  //     value.batchNo !== "" &&
  //     value.mfgDate !== "" &&
  //     value.expiryDate !== "" &&
  //     value.hsnCode !== "" &&
  //     value.mrp !== ""
  //   ) {
  //     this.props.AddItemMaster(this.state.value);
  //     this.setState({
  //       value: {

  //       }
  //     });
  //     this.props.closeAddModel();
  //     this.props.resetPage();
  //   } else {

  //   }
  // };

  submit = () => {
    const value = this.state.value;

    const err = this.validate();

    if (!err) {
      this.props.AddItemMaster(this.state.value);
      this.setState({
        value: {
          //  BrandId !== "Select Brand" &&
          //   drugCode !== "" &&
          //   drugName !== "" &&
          //  descp !== "" &&
          //   UnitId !== "Select Unit" &&
          //  unitPrice !== "" &&
          //   taxPernct !== "" &&
          //  taxAmnt !== "" &&
          //   unitCost !== "" &&
          //   ItemCatagoryId !== "Select Medical Type" &&
          //  remarks !== "" &&
          //  batchNo !== "" &&
          //   mfgDate !== "" &&
          //  expiryDate !== "" &&
          //  hsnCode !== "" &&
          //  mrp !== ""

          drugCode: '',
          drugName: '',
        },
        nameError: '',
        drugCodeError: '',
      });
      this.props.closeAddModel();
      this.props.resetPage();
    }
  };

  closeAddModel = () => {
    this.setState({
      value: {
        drugCode: '',
        drugName: '',
      },
      nameError: '',
      drugCodeError: '',
    });
    this.props.closeAddModel();
  };

  render() {
    return (
      <div>
        <Modal
          show={this.props.showitemmasterAddModel}
          onHide={this.props.closeAddModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
            closeButton
          >
            <Modal.Title>Item Master</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <div style={{marginTop: '10px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group>
                            <Form.Label> Brand</Form.Label>
                            <Form.Control
                              as="select"
                              // name="brand"
                              onChange={this.selectBrand}
                              // value={this.state.value.brand}
                            >
                              <option>Select Brand</option>
                              {this.props.BrandList &&
                                this.props.BrandList.map((item, i) =>
                                  <option key={i} value={item.id}>
                                    {item.name}
                                  </option>
                                )}
                            </Form.Control>
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="drugCode">
                            <Form.Label> Item Code </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="drugCode"
                              onChange={this.onChange}
                              value={this.state.value.drugCode}
                            />
                            <div className="errStyle">
                              {this.state.drugCodeError}
                            </div>
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="drugName">
                            <Form.Label> Item Name </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="drugName"
                              onChange={this.onChange}
                              value={this.state.value.drugName}
                            />
                            <div className="errStyle">
                              {this.state.nameError}
                            </div>
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>

              <div style={{marginTop: '10px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <Form.Group controlId="descp">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows="1"
                            name="descp"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.descp}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group>
                            <Form.Label> Unit</Form.Label>
                            <Form.Control
                              as="select"
                              // name="unitMeasure"
                              onChange={this.selectUnit}
                              // value={this.state.value.unitMeasure}
                            >
                              <option>Select Unit</option>
                              {this.props.UnitList &&
                                this.props.UnitList.map((item, i) =>
                                  <option key={i} value={item.id}>
                                    {item.name}
                                  </option>
                                )}
                            </Form.Control>
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="unitPrice">
                            <Form.Label> Unit Price </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="unitPrice"
                              onChange={this.onChange}
                              value={this.state.value.unitPrice}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>

              <div style={{marginTop: '10px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="taxPernct">
                            <Form.Label> Tax Percentage </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="taxPernct"
                              onChange={this.onChange}
                              value={this.state.value.taxPernct}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="taxAmnt">
                            <Form.Label> Tax Amount </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="taxAmnt"
                              onChange={this.onChange}
                              value={this.state.value.taxAmnt}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="unitCost">
                            <Form.Label>Unit Cost </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="unitCost"
                              onChange={this.onChange}
                              value={this.state.value.unitCost}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>

              <div style={{marginTop: '10px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div>
                        <div>
                          <Form.Group>
                            <Form.Label> Medical Type</Form.Label>
                            <Form.Control
                              as="select"
                              onChange={this.selectMedicalType}
                            >
                              <option>Select Medical Type</option>
                              {this.props.MedicalTypeList &&
                                this.props.MedicalTypeList.map((item, i) => (
                                  <option key={i} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </div>
                      </div>
                    </Form> */}
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="mrp">
                            <Form.Label>MRP </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="mrp"
                              onChange={this.onChange}
                              value={this.state.value.mrp}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div>
                        <Form.Group controlId="remarks">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows="1"
                            name="remarks"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.remarks}
                          />
                        </Form.Group>
                      </div>
                    </Form> */}

                    <Form>
                      <div>
                        <div>
                          <Form.Group>
                            <Form.Label> Medical Type</Form.Label>
                            <Form.Control
                              as="select"
                              onChange={this.selectMedicalType}
                            >
                              <option>Select Medical Type</option>
                              {this.props.MedicalTypeList &&
                                this.props.MedicalTypeList.map((item, i) =>
                                  <option key={i} value={item.id}>
                                    {item.name}
                                  </option>
                                )}
                            </Form.Control>
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div>
                        <div>
                          <Form.Group controlId="batchNo">
                            <Form.Label> Batch Number </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="batchNo"
                              onChange={this.onChange}
                              value={this.state.value.batchNo}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form> */}
                    <Form>
                      <div>
                        <Form.Group controlId="remarks">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows="1"
                            name="remarks"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.remarks}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>
              <div style={{marginTop: '15px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div style={{ maxWidth: 250, margin: "auto" }}>
                        <Form.Group controlId="mfgDate">
                          <Form.Label>Maufacture Date</Form.Label>
                          <DatePicker
                            className="invoiceDatePicker"
                            selected={this.state.value.mfgDate}
                            name="mfgDate"
                            placeholder="dd-MM-yyyy"
                            onChange={this.handleChangedate}
                            dateFormat="dd-MM-yyyy"
                          ></DatePicker>
                        </Form.Group>
                      </div>
                    </Form> */}

                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="batchNo">
                            <Form.Label> Batch Number </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="batchNo"
                              onChange={this.onChange}
                              value={this.state.value.batchNo}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div style={{ maxWidth: 250, margin: "auto" }}>
                        <Form.Group controlId="expiryDate">
                          <Form.Label>Expiry Date</Form.Label>
                          <DatePicker
                            className="invoiceDatePicker"
                            selected={this.state.value.expiryDate}
                            name="expiryDate"
                            onChange={this.handleChangeexpiryDate}
                            dateFormat="dd-MM-yyyy"
                            minDate={new Date()}
                          ></DatePicker>
                        </Form.Group>
                      </div>
                    </Form> */}

                    <Form>
                      <div style={{maxWidth: 250, margin: 'auto'}}>
                        <Form.Group controlId="mfgDate">
                          <Form.Label>Maufacture Date</Form.Label>
                          <DatePicker
                            className="invoiceDatePicker"
                            selected={this.state.value.mfgDate}
                            name="mfgDate"
                            placeholder="dd-MM-yyyy"
                            onChange={this.handleChangedate}
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div>
                        <div>
                          <Form.Group controlId="hsnCode">
                            <Form.Label> Hsn Code </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="hsnCode"
                              onChange={this.onChange}
                              value={this.state.value.hsnCode}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form> */}
                    <Form>
                      <div style={{maxWidth: 250, margin: 'auto'}}>
                        <Form.Group controlId="expiryDate">
                          <Form.Label>Expiry Date</Form.Label>
                          <DatePicker
                            className="invoiceDatePicker"
                            selected={this.state.value.expiryDate}
                            name="expiryDate"
                            onChange={this.handleChangeexpiryDate}
                            dateFormat="dd-MM-yyyy"
                            minDate={new Date()}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>
              <div style={{marginTop: '15px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="hsnCode">
                            <Form.Label> HSN Code </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="hsnCode"
                              onChange={this.onChange}
                              value={this.state.value.hsnCode}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{backgroundColor: '#f0f3f5'}}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ItemMasterAdd;
